import React from 'react';
import Flagship from '../../core/flagship';
import {getFormattedValue, isEqual, empty} from '../../utils/helpers';
import {Link} from 'react-router';
import { Button, Feed, Label, Loader, Segment, Icon, Tab } from 'semantic-ui-react';
import '../../styles/activityFeed.scss';

class ActivityFeed extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.refreshFeed = this.refreshFeed.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.getData = this.getData.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    // Separate component state for UI only
    getInitialState() {
        return {
            offset: 0,
            items: [],
            error: '',
            loading: false,
            pane: 0
        }
    }

    componentDidMount() {
        this.refreshFeed();
        this.interval = setInterval(this.refreshFeed.bind(this),120000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        this.interval = null;
    }

    nextPage() {
        let newOffset = this.state.offset + 5;
        this.setState({
            offset: newOffset
        });
        this.getFeedItems(newOffset);
    }

    prevPage() {
        let newOffset = this.state.offset - 5;
        if (newOffset < 0) {
            newOffset = 0;
        }
        this.setState({
            offset: newOffset
        });
        this.getFeedItems(newOffset);
    }

    getFeedItems(offset) {
        this.setState({
            loading:true
        });
        let self = this;

        if (this.state.pane === 0) {

            Flagship.get(
                "subscriptions/read",
                {
                    offset,
                    subscriber: self.props.userId,
                    count: 5
                },
                function(response) {
                    if (response.data.success === true ) {
                        self.setState(
                            {
                                items:  response.data.results,
                                loading: false

                            });
                    } else {
                        self.setState(
                            {
                                error: "Failed to load subscription activity.",
                                loading: false
                            }
                        );
                    }
                }, function(err) {
                    console.log("ERROR: " + err);
                }
            );

        } else if (this.state.pane === 1 ) {

            Flagship.get(
                "log/read",
                {
                    offset,
                    exclude: 'error',
                    count: 5
                },
                function(response) {
                    if (response.data.success === true ) {
                        self.setState(
                            {
                                items:  response.data.results,
                                loading: false

                            });
                    } else {
                        self.setState(
                            {
                                error: "Failed to load recent activity.",
                                loading: false
                            }
                        );
                    }
                }, function(err) {
                    console.log("ERROR: " + err);
                }
            );

        } else {
            this.setState({
                pane: 0
            }, function() {
                this.refreshFeed();
            })
        }
    }

    refreshFeed() {
        this.getFeedItems(this.state.offset);
    }

    handleTabChange(e, data) {
        this.setState({
            items: [],
            offset: 0,
            loading:true,
            pane: data.activeIndex
        }, function() {
           this.refreshFeed();
        });
    }


    getMessage(action) {
        if ( Flagship.config.possibleActions.hasOwnProperty(action) ) {
            return Flagship.config.possibleActions[action]
        }
        return '';
    }

    getRecordTitle(name, key, type) {
        let icon = 'exclamation';
        switch (type) {
            case 'client':
                icon = 'briefcase';
                break;
            case 'rfp':
                icon = 'dollar';
                break;
            case 'io':
                icon = 'rocket';
                break;
            case 'line_item':
                icon = 'pin';
                break;
            case 'io_product':
                icon = 'pin';
                break;
        }

        if ( type === "rfp" || type === "io" ) {
            name = '#' + key + ' - ' + name;
        }
        return (
            <h3>
                <Icon className="feed-icon" disabled size="large" color="grey" name={icon} />
                {name}
            </h3>
        );
    }


    renderFieldDiff(label, newValue, oldValue, validation = false, key = false) {


        if (!isEqual(newValue, oldValue)) {

            if (validation) {
                if ( validation !== "client-name" ) {
                    oldValue = getFormattedValue(oldValue, validation);
                    newValue = getFormattedValue(newValue, validation);
                } else {
                    oldValue = oldValue.name;
                    newValue = newValue.name;
                }
            }
            return (
                <div className="single-field-change" key={key ? 'change-' + key : label}>
                    <Label>{label}</Label>
                    <br/>
                    <div className="edit-value-values">
                        { !empty(newValue) ? <span className="edit-value-new">{newValue}</span> : null }
                        { !empty(oldValue) ? <span className="edit-value-old">{oldValue}</span>: null }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    getData(action, data, name, key, type) {


        if (typeof type !=="undefined" && type !== null) {

            switch (action) {
                case 'comment':
                    return (
                        <Segment className="cf" style={{wordWrap:"break-word", maxWidth:"100%", wordBreak:"break-all"}}>
                            {this.getRecordTitle(name, key, type)}
                            <Icon size="large" color="grey" name="quote left"/>
                            <em>{data}</em>
                        </Segment>
                    );
                case 'create-client':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="user" color="grey"/>
                                <em><strong>DBS: </strong> {data.extra1}</em>
                            </div>
                        </Segment>
                    );
                case 'create-rfp':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="briefcase" color="grey"/>
                                <em><strong>Client: </strong> {data.extra1.name}</em>
                            </div>
                        </Segment>
                    );
                case 'create-io':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="briefcase" color="grey"/>
                                <em><strong>RFP: </strong> #{data.extra1.key} - {data.extra1.name}</em>
                            </div>
                        </Segment>
                    );
                case 'create-line-item':

                    if (!data.hasOwnProperty("lineItemKey")) {
                        return (
                            <Segment className="cf">
                                {this.getRecordTitle(name, key, type)}
                                <div>
                                    <Icon name="pin" color="grey"/>
                                    <em><strong>Added: </strong> {data}</em>
                                </div>
                            </Segment>
                        );
                    }

                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Added: </strong>{data.lineItemName}</em>
                            </div>
                        </Segment>
                    );
                case 'create-io-product':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Added: </strong> {data}</em>
                            </div>
                        </Segment>
                    );
                case 'update-line-item':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Updated: </strong> {data.lineItemName}</em>
                            </div>
                        </Segment>
                    );
                case 'update-line-item-pricing':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="dollar" color="grey"/>
                                <em><strong>Updated: </strong> {data.lineItemName}</em>
                            </div>
                        </Segment>
                    );
                case 'update-io-product':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Updated: </strong> {data.ioProductName}</em>
                            </div>
                        </Segment>
                    );
                case 'update-io-product-assignment':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Updated: </strong> {data.ioProductName}</em><br/>
                                <div className="flagship-single-field">
                                <Label style={{marginBottom:".5em"}}>New Assignee</Label> {getFormattedValue(data.newAssignee, "user")}
                                </div>
                            </div>
                        </Segment>
                    );
                case 'update-io-product-status':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="pin" color="grey"/>
                                <em><strong>Updated: </strong> {data.ioProductName}</em>
                            </div>
                            <div className="statuses-feed">
                                <Label
                                    content={Flagship.config.records[type].ioProductStatuses[data.oldStatus].label}
                                    className="strikethrough"
                                />
                                <Label
                                    color={Flagship.config.records[type].ioProductStatuses[data.newStatus].color}
                                    content={Flagship.config.records[type].ioProductStatuses[data.newStatus].label}
                                />
                            </div>
                        </Segment>
                    );
                case 'change':
                    if (data !== null && typeof data.new === 'string' && typeof data.old === 'string') {
                        return (
                            <Segment className="cf">
                                {this.getRecordTitle(name, key, type)}
                                {this.renderFieldDiff(data.label, data.new, data.old)}
                            </Segment>
                        );
                    } else if (data !== null) {
                        let renderFieldDiff = this.renderFieldDiff;
                        return (
                            <Segment className="cf">
                                {this.getRecordTitle(name, key, type)}
                                {typeof data.map === "function" ?
                                    data.map(function (item, i) {
                                        return renderFieldDiff(item.label, item.new, item.old, item.validation, i)
                                    }) : null }

                            </Segment>
                        );
                    } else {
                        return (
                            <Segment className="cf">
                                {this.getRecordTitle(name, key, type)}
                            </Segment>
                        );
                    }
                case 'change-status-io':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Label color={Flagship.config.records[type].statuses[data].color}
                                       content={Flagship.config.records[type].statuses[data].label}/>
                            </div>
                        </Segment>
                    );
                case 'change-status-rfp':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Label color={Flagship.config.records[type].statuses[data].color}
                                       content={Flagship.config.records[type].statuses[data].label}/>
                            </div>
                        </Segment>
                    );
                case 'file-upload':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="file" color="grey"/>
                                <em><strong>Uploaded: </strong>{data}</em>
                            </div>
                        </Segment>
                    );
                case 'proposal-upload':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <Icon name="file text outline" color="grey"/>
                                <em><strong>Uploaded: </strong>{data}</em>
                            </div>
                        </Segment>
                    );
                case 'change-business-closed':
                    return (
                        <Segment className="cf">
                            {this.getRecordTitle(name, key, type)}
                            <div>
                                <div className="single-field-change" key={key ? 'change-' + key : 'no-key'}>
                                    <Label>Date Business Closed</Label><br/>
                                    <div className="field-value feed-business-closed">
                                        <Icon name="calendar" color="grey"/>
                                        {getFormattedValue(data, "date")}
                                    </div>
                                </div>
                            </div>
                        </Segment>
                    );
            }
        }
    }

    renderPagination() {
        if (this.state.offset > 0 && this.state.items.length === 5) {
            return (
                <Button.Group fluid className="activity-feed-pagination">
                    <Button secondary onClick={this.prevPage}>Previous Page</Button>
                    <Button.Or/>
                    <Button primary onClick={this.nextPage}>Next Page</Button>
                </Button.Group>
            );
        } else if (this.state.offset > 0 ) {
            return (
                <Button.Group fluid className="activity-feed-pagination">
                    <Button secondary onClick={this.prevPage}>Previous Page</Button>
                </Button.Group>
            );
        } else if (this.state.items.length === 5){
            return (
                <Button.Group fluid className="activity-feed-pagination">
                    <Button primary onClick={this.nextPage}>Next Page</Button>
                </Button.Group>
            );
        } else {
            return (
                <span>No {this.state.offset === 0 && this.state.items.length === 0 ? null : "other"} activity to display.</span>
            )
        }
    }



    render() {
        let getMessage = this.getMessage;
        let getData = this.getData;

        let renderPane = () => {
            return (
                <Segment className="fade-in recent-activity">
                    <Feed>
                      {this.state.error !== '' ? this.state.error : ''}

                      {typeof this.state.items !== "undefined" ? this.state.items.map(function(item, i) {

                          let maybeAddFocus = '';

                          if (
                              (
                                  item.action === "create-line-item" ||
                                  item.action === "update-line-item"
                              ) && item.data.hasOwnProperty("lineItemKey")
                          ) {
                              maybeAddFocus = "/focus/" + item.data.lineItemKey;
                          } else if (
                              (
                                item.action === "create-io-product" ||
                                item.action === "update-io-product"
                              ) && item.data.hasOwnProperty("ioProductKey")
                          ) {
                              maybeAddFocus = "/focus/" + item.data.ioProductKey;
                          }

                          return (

                              <Feed.Event key={"feed-item-" + i}>
                                  <Feed.Label>
                                      <img src={Flagship.config.uploads + item.photo} alt={item.first_name} />
                                  </Feed.Label>
                                  <Feed.Content>
                                      <Feed.Summary>
                                          <Feed.User>{item.first_name + ' ' + item.last_name} </Feed.User>
                                          <span> {getMessage(item.action)}</span>
                                          <Feed.Date>
                                              {getFormattedValue(item.date, 'time ago')}
                                          </Feed.Date>
                                      </Feed.Summary>
                                      <Feed.Extra text>
                                          <Link className="single-dash-widget-record" to={'/' + item.record_type + '/view/' + item.record_key + maybeAddFocus}>
                                              {getData(item.action, item.data, item.record_name, item.record_key, item.record_type)}
                                          </Link>
                                      </Feed.Extra>
                                  </Feed.Content>
                              </Feed.Event>

                          )
                      }) : <div>Could not load feed.</div>}

                        {this.renderPagination()}
                        <span>&nbsp;</span>&nbsp;
                        {this.state.loading === true ? <Loader className="flagship-loader" active={this.state.loading} inline /> : null }
                    </Feed>
                </Segment>
            );
        };

        const panes = [
            { menuItem: 'My Subscriptions', render: () => renderPane() },
            { menuItem: 'All Activity', render: () => renderPane() }
        ];
        return (
            <Tab panes={panes} onTabChange={this.handleTabChange} className="fade-in activity-feed-tabs" />
        );
    }
}
export default ActivityFeed;





// WEBPACK FOOTER //
// ./src/components/dashboard/ActivityFeed.js